import {createSlice} from '@reduxjs/toolkit';
import {DISPOSITION_CODE, PHASE, STATE} from '../../../constants/Lookup';
import {httpGet, httpPost} from '../../../util/Rest';
import {submissionEnd} from '../CommonActions/commonActions';

const initialState = {
  clientParentData: {},
  clientCodeData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  dropDownData: {},
  accountNumber: '',
};

const addParent = createSlice({
  name: 'addParent',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getClientParentData: (state, action) => {
      state.clientParentData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getclientCodeData: (state, action) => {
      state.clientCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postPatientData: (state, action) => {
      state.addPatientStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.accountNumber = action.payload?.response;
    },
    resetClientCodeData: (state) => {
      state.clientCodeData = {};
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.addPatientStatus = null;
    },
  },
});

export default addParent.reducer;

const {
  getClientParentData,
  fetchStart,
  fetchDropDownData,
  fetchError,
  getclientCodeData,
  resetClientCodeData,
  postPatientData,
  resetMsg,
} = addParent.actions;

export const fetchClientParentData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`client/find/all/parentname`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClientParentData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const getClientCodes = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`client/find/all/client/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getclientCodeData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postPatientContact = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`accountsummary/save/addpatient`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (
          data &&
          data.status &&
          data.status === 200 &&
          data?.data?.status === 400 &&
          data?.data?.message
        ) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200 && data?.data?.status !== 400) {
          dispatch(postPatientData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [DISPOSITION_CODE, PHASE, STATE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetClientCode = () => {
  return (dispatch) => {
    dispatch(resetClientCodeData());
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
